import React, { type PropsWithChildren } from 'react';
import Fade from '@jwp/ott-ui-react/src/components/Animation/Fade/Fade';

export type Props = {
  title: string;
  className?: string;
};

const Tab = ({ children, title, className }: PropsWithChildren<Props>) => (
  <div className={className} role="tabpanel">
    <Fade open duration={500}>
      <h2 className="hidden">{title}</h2>
      {children}
    </Fade>
  </div>
);

export default Tab;
